<mat-card>
  <form #form="ngForm" novalidate autocomplete="off" (ngSubmit)="onLogin()">
    <img src="assets/images/aspen-logo.svg" alt="" class="brand-logo" />

    <div class="form-container">
      <mat-form-field appearance="outline">
        <mat-icon matPrefix><img src="assets/images/icon-user-login.svg" /></mat-icon>
        <input name="username" [(ngModel)]="username" autocomplete="off" matInput placeholder="Username"
          matInputAutofocus />
      </mat-form-field>
    </div>

    <div class="form-container">
      <mat-form-field appearance="outline">
        <mat-icon matPrefix><img src="assets/images/icon-password.svg" /></mat-icon>
        <input name="password" [(ngModel)]="password" autocomplete="off" matInput
          [type]="clearText ? 'text' : 'password'" placeholder="Password" />
      </mat-form-field>
    </div>

    <div class="form-container">
      <section class="custom-check-box-group">
        <mat-checkbox class="custom-check-box" name="clearText" [(ngModel)]="clearText">Show password in clear text
        </mat-checkbox>
      </section>
    </div>

    <button mat-raised-button color="accent">LOGIN</button>

    <a class="reset-pass" (click)="sendEmail()">
      <mat-icon> <img src="assets/images/icon-change-password-login.svg" /> </mat-icon>Send reset
      password email
    </a>

    <div class="alert alert-warning" *ngIf="badLogin">Invalid username or password. If you have lost your user ID,
      please contact Support</div>
    <div class="alert alert-general" *ngIf="resetEmail">A reset email has been sent to the email address we have for
      this user on the system</div>
    <div class="alert alert-warning" *ngIf="noResetUsename">Please enter your username first</div>
    <div class="alert alert-warning" *ngIf="sendEmailError">Error sending reset email, please contact Support</div>
  </form>
</mat-card>
